import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { Button } from '../StyledComponents';
import { ApparelContext } from '../context/FlowContext';

const AnotherDesignOption = ({ setCurrentStep, nextStep }) => {
  const { totalSelectedDesignNums } = useContext(ApparelContext);

  useEffect(() => {
    if (totalSelectedDesignNums === 5) {
      nextStep();
    }
  }, [totalSelectedDesignNums, nextStep]);

  return (
    <StyledFormStep
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Do You Want to Request Designs for Another Garment?</h2>

      <div className="row">
        <Button onClick={() => setCurrentStep(2)}>YES</Button>
        <Button className="outlined" onClick={() => nextStep()}>
          NO
        </Button>
      </div>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  @media (max-width: 991px) {
    padding: 20px 20px 100px;
  }

  h2 {
    margin-top: 0;
    margin-bottom: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
`;

export default AnotherDesignOption;
